import posthog from 'posthog-js'

/**
 * Track an event in PostHog. Safe to call server-side (no-ops).
 * Runs alongside existing sendGAEvent calls — does not replace them.
 */
export function trackEvent(name: string, properties?: Record<string, any>) {
  if (typeof window !== 'undefined' && posthog.__loaded) {
    posthog.capture(name, properties)
  }
}

/** True when PostHog runs with full (non-cookieless) tracking for this visitor. */
export function hasFullTracking(): boolean {
  return typeof window !== 'undefined' && !!posthog.__loaded && posthog.has_opted_in_capturing()
}

/**
 * Identify an anonymous newsletter subscriber in PostHog using their email.
 * Merges prior anonymous browsing history into the email-based identity.
 * If the user later signs up with Clerk, the provider's identify(userId)
 * call will automatically merge the email identity into the Clerk ID
 * (PostHog v2 identity handles this natively).
 *
 * Only fires with full tracking (non-European visitor or banner consent): cookieless
 * visitors must never have an email attached. No-op otherwise.
 */
export function identifyNewsletterSubscriber(email: string) {
  if (hasFullTracking()) {
    posthog.identify(email, { email, newsletter_subscriber: true })
  }
}
